/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

import { Theme } from '../../enum/theme.enum';
import { CheckState } from '../../enum/check-state.enum';
import { Selectable } from '../../interface/selectable';
import { ActionNoticeBadgeEnum } from '../../enum/action-notice-badge.enum';
import { CommonUtils } from '../common-utils';

export enum ActionType {
  success = 'success',
  danger = 'danger',
  info = 'info',
  primary = 'primary',
  classic = 'classic',
}

export class SimpleAction<T> implements Selectable {
  public name: string;
  public icon: string;
  public text: string;
  public data: T;
  public value: T;
  public border: boolean;
  public type: ActionType;
  public category: string;
  public theme: Theme;
  public align: 'right' | 'left' | 'center' = 'right';
  public enable = true;
  public visible = true;
  public fontAwesome = 'fal';
  public iconColor: string;
  public textColor: string;
  public tooltip: string;
  public bold: boolean;
  public group: number;
  public secondaryIcon: string;
  public secondaryIconPosition: 'corner' | 'center' = 'corner';
  public topLine: boolean;
  public bottomLine: boolean;
  public picto: string;
  public showText: boolean;
  public noticeBadge: ActionNoticeBadgeEnum;

  public isHighlighted = false;
  public highlightedColor = CommonUtils.color('black');
  public highlightedBackgroundColor = '#FEF2DC';

  public constructor(
    name: string,
    icon: string,
    data: T,
    text: string,
    type?: ActionType,
  ) {
    this.name = name;
    this.icon = icon;
    this.text = text;
    this.data = data;
    this.type = type ? type : ActionType.classic;
    this.category = 'simple';
  }

  public get checkState(): CheckState {
    return this.check ? CheckState.check : CheckState.uncheck;
  }

  public get normalizedText(): string {
    return CommonUtils.normalize(this.text, true);
  }

  protected _check: boolean;

  public get check(): boolean {
    return this._check;
  }

  public set check(value: boolean) {
    this._check = value;
  }

  getActionType() {
    return 'simple';
  }

  public toString() {
    return this.text;
  }

  public compare(item: any): number {
    if (item instanceof SimpleAction) {
      return this.name.localeCompare(item.name);
    }
    if (typeof item === 'string') {
      return this.name.localeCompare(item);
    }
    return 0;
  }
}
